module.exports = __webpack_public_path__ + "img/photograph2.85080286.png";